import React from 'react'
import PropTypes from 'prop-types'

const CLASSES = 'tw:bg-transparent tw:border-0 tw:p-0 tw:font-medium tw:underline tw:cursor-pointer '
  + 'tw:text-ds-primary tw:hover:text-ds-primary-hover tw:active:text-ds-primary-pressed '
  + 'tw:disabled:opacity-50 tw:disabled:cursor-not-allowed'

const LinkButton = ({ children, className, disabled, onClick, type }) => (
  <button
    className={`${CLASSES} ${className}`.trim()}
    disabled={disabled}
    type={type === 'submit' ? 'submit' : 'button'}
    onClick={onClick}
  >
    {children}
  </button>
)

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit'])
}

LinkButton.defaultProps = {
  className: '',
  disabled: false,
  onClick: null,
  type: 'button'
}

export default LinkButton
